import { ApiClientBase } from "api/ApiClientBase";

class ReportsApiClient extends ApiClientBase {
    getReportStatus(taskId) {
        return this.get(`api/v1/reports/report/${taskId}/status`).then((r) => r.data);
    }

    getReportResult(taskId) {
        return this.get(`api/v1/reports/report/${taskId}`).then((r) => r.data);
    }

    getDownloadReportUrl(taskId) {
        return `api/v1/reports/report/${taskId}/download`;
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new ReportsApiClient();
